import React, { useState } from "react";
import axios from "axios";
import '../css/adminEvent.css';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AdminAddEvent = () => {
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const navigate = useNavigate();
  const url = process.env.REACT_APP_BASE_URL

  const handleAddEvent = async () => {
    try {
      const response = await axios.post(`${url}/api/events/add`, {
        eventName,
        eventDate,
      });
      if (response.status === 201) {
        toast.success("Event added successfully.")
      
        navigate("/admin/dashboard/event"); // Redirect to AdminEvent page
      }
    } catch (error) {
      toast.error("Error adding event");
      console.error("Error adding event:", error);
      alert("Failed to add event. Please try again.");
    }
  };

  return (
    <div className="add-event-container">
      <h1>Add Event</h1>
      <table className="add-event-table">
        <tbody>
          <tr>
            <td>Event Name:</td>
            <td>
              <input
                type="text"
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td>Event Date:</td>
            <td>
              <input
                type="date"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <button className="submit-button" onClick={handleAddEvent}>Add Event</button>
    </div>
  );
};

export default AdminAddEvent;
